import { render, staticRenderFns } from "./designationtable.vue?vue&type=template&id=2bc1ead6"
import script from "./designationtable.vue?vue&type=script&lang=js"
export * from "./designationtable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports